/**
 * Reflects different versions of barrel data.
 * Categorized as where these versions are mainly used:
 * - Bare: Space view
 * - Partial: Preview view
 * - Complete: Barrel detail view
 */
enum BarrelDataStage {
    Bare = "bare",
    Partial = "partial",
    Complete = "complete"
}

export default BarrelDataStage;
